export default class SmartScroll {
    constructor(container) {
    this.container = container;
    this.autoScrollEnabled = true;
    this.lastScrollTop = 0;
    this.scrollTimeout = null;
    
    this.bindEvents();
  }
  
  bindEvents() {
    this.container.addEventListener('scroll', this.handleScroll.bind(this));
  }
  
  handleScroll() {
    // 清除之前的定时器
    clearTimeout(this.scrollTimeout);
    
    const scrollTop = this.container.scrollTop;
    const isScrollingUp = scrollTop < this.lastScrollTop;
    this.lastScrollTop = scrollTop;
    
    // 检查是否在底部
    const isAtBottom = this.isAtBottom();

    if (isAtBottom) {
      this.autoScrollEnabled = true;
    } else if (isScrollingUp) {
      this.autoScrollEnabled = false;
    }
    
    // 设置超时后重新检查，防止快速滚动时的误判
    this.scrollTimeout = setTimeout(() => {
      if (this.isAtBottom()) {
        this.autoScrollEnabled = true;
      }
    }, 300);
  }
  
  isAtBottom(threshold = 5) {
    return this.container.scrollHeight - this.container.scrollTop <= 
           this.container.clientHeight + threshold;
  }
  
  scrollToBottom() {
    if (this.autoScrollEnabled) {
      this.container.scrollTop = this.container.scrollHeight;
    }
  }
  
  addContent(content) {
    // 添加内容的逻辑...
    this.scrollToBottom();
  }

  stop() {
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = null;
    this.container.removeEventListener('scroll', this.handleScroll);
    this.autoScrollEnabled = true;
    this.lastScrollTop = 0;
  }
}